import { DataGridPro } from '@mui/x-data-grid-pro';

import useForecastGeneralDetailData from '../../../Queries/forecastGeneralDetailQuery';
import { columns, getGridStyles, getRowHeight, getRowId, slots } from './utils';
import ErrorCard from 'views/Components/Shared/Components/ErrorCard';

export default function DetailPanel({ row }) {
	const forecastGeneralDetailQuery = useForecastGeneralDetailData({
		productId: row?.product_id,
	});

	// if (forecastGeneralDetailQuery.status === 'pending') {
	// 	return <Skeletons />;
	// }

	if (forecastGeneralDetailQuery.status === 'error') {
		return <ErrorCard handleReload={forecastGeneralDetailQuery.refetch} />;
	}

	return (
		<div>
			<DataGridPro
				loading={forecastGeneralDetailQuery.status === 'pending'}
				rows={forecastGeneralDetailQuery.data?.items || []}
				getRowId={getRowId}
				columns={columns}
				pageSize={25}
				getRowHeight={getRowHeight}
				disableColumnMenu
				disableRowSelectionOnClick
				disableColumnReorder
				hideFooter
				columnHeaderHeight={0}
				slots={slots}
				// disableVirtualization
				sx={getGridStyles(forecastGeneralDetailQuery.data?.items?.length === 0)}
			/>
		</div>
	);
}
